import { render, staticRenderFns } from "./CarrierTable.vue?vue&type=template&id=5f6f95dd&"
import script from "./CarrierTable.vue?vue&type=script&lang=ts&"
export * from "./CarrierTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports